import { defineStore } from 'pinia'
import { reactive } from 'vue'

export interface IMegaMenuStoreState {
	cars: { [key: string]: IProductModel[] }
	areCarsLoading: boolean
	groupID?: number
}

export interface IMegaMenuStore {
	readonly state: {
		cars: { [key: string]: IProductModel[] }
		areCarsLoading: boolean
		groupID?: number
	}
	fetchCarsWithFilters: (
		groupsFromDb: IProductGroupModel[],
		filters?: string[],
	) => Promise<
		| IProductModel[]
		| {
				response: IProductModel[]
				links: IApiLinks | undefined
		  }
	>
	setCars: (cars: IProductModel[], groupName: string) => void
	clearCars: () => void
	setAreCarsLoading: (areCarsLoading: boolean) => void
	setGroupID: (groupID: number) => void
	getAreCarsLoading: ComputedRef<boolean>
	getGroupID: ComputedRef<number | undefined>
}

export const useMegaMenuStore = defineStore('megaMenuStore', (): IMegaMenuStore => {
	// const carsStore = useCarsStore()
	// const allGroups = computed(() => carsStore.getAllGroups)

	const _state = reactive<IMegaMenuStoreState>({
		cars: {
			all: [],
			[EGroupName.ELECTRIC]: [],
			[EGroupName.DELIVERY]: [],
		},
		areCarsLoading: true,
		groupID: undefined,
	})

	const setCars = (cars: IProductModel[], groupName: string) => {
		if (!_state.cars[groupName]) return
		_state.cars[groupName] = cars
	}

	const setAreCarsLoading = (areCarsLoading: boolean) => {
		_state.areCarsLoading = areCarsLoading
	}

	const setGroupID = (groupID: number) => {
		_state.groupID = groupID
	}

	const getAreCarsLoading = computed(() => _state.areCarsLoading)

	const getGroupID = computed(() => _state.groupID)

	const clearCars = () => {
		_state.cars = {
			all: [],
			[EGroupName.ELECTRIC]: [],
			[EGroupName.DELIVERY]: [],
		}
	}

	const fetchCarsWithFilters = async (groupsFromDb: IProductGroupModel[], searches?: string[]) => {
		setAreCarsLoading(true)
		if (searches) {
			if (_state.cars[searches[0]] && _state.cars[searches[0]].length > 0) {
				setTimeout(() => setAreCarsLoading(false), 250)
				return _state.cars[searches[0]]
			}
		} else if (!searches) {
			if (_state.cars.all && _state.cars.all.length > 0) {
				setTimeout(() => setAreCarsLoading(false), 250)
				return _state.cars.all
			}
		}

		const groups: {
			id: string
			values: number[]
		} = {
			id: 'group_id',
			values: [],
		}

		const searchesToRequest: IProductParameterSearch[] = []

		// for every filter, find corresponding name in carsStore.getAllGroups, and push id of that element to groups.values
		if (searches && groupsFromDb) {
			searches.forEach((filter) => {
				const group = groupsFromDb?.find((group) => group.name === filter)
				if (group) {
					groups.values.push(group.id)
				}
			})

			searchesToRequest.push(groups)
		}
		// const date_out = bookerStore.getBookerDates.start
		// const date_in = bookerStore.getBookerDates.end
		// const location_out = bookerStore.getBookerStartLocation
		const filters: IProductFilter[] = []

		// if (date_out) {
		// 	filters.push({
		// 		id: 'date_out',
		// 		value: format(date_out, 'dd-MM-yyy HH:mm:ss'),
		// 	})
		// }

		// if (date_in) {
		// 	filters.push({
		// 		id: 'date_in',
		// 		value: format(date_in, 'dd-MM-yyy HH:mm:ss'),
		// 	})
		// }

		// if (location_out?.crmID) {
		// 	filters.push({
		// 		id: 'office_id',
		// 		value: location_out.crmID,
		// 	})
		// }

		filters.push({
			id: 'has_price',
			value: '1',
		})

		const { response, links } = await ApiService.fetchProductsByParameters(searchesToRequest, filters, 1, 16)

		// save fetched cars to store
		if (response && searches) {
			setCars(response, searches[0])
		} else if (response) {
			setCars(response, 'all')
		}

		setAreCarsLoading(false)
		return { response, links }
	}

	return {
		state: _state,
		setCars,
		fetchCarsWithFilters,
		setAreCarsLoading,
		clearCars,
		setGroupID,
		getAreCarsLoading,
		getGroupID,
	}
})
